import { render, staticRenderFns } from "./ExtractionFieldGroupHeader.vue?vue&type=template&id=f49dd8f2&scoped=true&"
import script from "./ExtractionFieldGroupHeader.vue?vue&type=script&lang=js&"
export * from "./ExtractionFieldGroupHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExtractionFieldGroupHeader.vue?vue&type=style&index=0&id=f49dd8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49dd8f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
